import type { IDtefComparisonItem } from "@/@types/store-conciliation"

import { DtefComparisonRow } from "./dtef-comparison-row"

interface DtefComparisonRowWithFallbackProps {
  label: string
  comparison: IDtefComparisonItem | null | undefined
  fallbackVarValue: number
  fallbackDtefValue: number
}

export function DtefComparisonRowWithFallback({
  label,
  comparison,
  fallbackVarValue,
  fallbackDtefValue,
}: DtefComparisonRowWithFallbackProps) {
  return (
    <DtefComparisonRow
      label={label}
      varValue={comparison?.var ?? fallbackVarValue}
      dtefValue={comparison?.dtef ?? fallbackDtefValue}
      divergent={comparison?.divergent ?? false}
    />
  )
}
